import React from "react";
import { Skeleton } from "../PainelShimmerChrome";
import "./UsuariosTableSkeleton.scss";

const ROW_COUNT = 8;

interface UsuariosTableSkeletonProps {
  isDarkMode?: boolean;
}

const UsuariosTableSkeleton: React.FC<UsuariosTableSkeletonProps> = ({
  isDarkMode = false,
}) => (
  <div
    className={`usuarios-table-skeleton__wrap${isDarkMode ? " usuarios-table-skeleton__wrap--dark" : ""}`}
    aria-busy="true"
    aria-label="Carregando usuários"
  >
    <table className="usuarios-table-skeleton__table">
      <thead>
        <tr>
          <th>Nome</th>
          <th>E-mail</th>
          <th>Login Tasy</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: ROW_COUNT }, (_, i) => (
          <tr key={i} className="usuarios-table-skeleton__row">
            <td className="usuarios-table-skeleton__cell">
              <Skeleton height={14} width="78%" />
            </td>
            <td className="usuarios-table-skeleton__cell">
              <Skeleton height={14} width="88%" />
            </td>
            <td className="usuarios-table-skeleton__cell">
              <Skeleton height={14} width="56%" />
            </td>
            <td className="usuarios-table-skeleton__cell">
              <div className="usuarios-table-skeleton__actions">
                <Skeleton height={32} width={32} borderRadius="50%" />
                <Skeleton height={32} width={32} borderRadius="50%" />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default UsuariosTableSkeleton;
